import { useRef, useContext, useState, useEffect } from 'react';
import { MainContext } from '../../contexts/main';
import { BillingFormContext } from '../../contexts/billingForm';
import { markBudgetAsSeen, generateBudget } from '../../helpers/api';
import { getText } from '@educaplay/app-core/language';
import { getURL } from '../../helpers/urls';
import { SVG_copy, SVG_link, SVG_payforme, SVG_chevron_down } from '../elements/SVG';
import { BlockLoading } from './BlockLoading';
import config from '../../resources/config.json';

export const BlockPayForMe = () => {

    const { environment, mainReducer } = useContext( MainContext );
    const billingForm = useContext( BillingFormContext );

    const [ stateExpanded, setStateExpanded ] = useState(false);
    const [ stateGenerating, setStateGenerating ] = useState(false);
    const [ stateCopied, setStateCopied ] = useState(false);

    const inputPayForMe = useRef(null);

    useEffect( () => {
        setStateCopied(false);
    }, [ mainReducer.state.budgetGenerated ]);

    useEffect(() => {
        if (mainReducer.state.budgetGenerated === false && stateExpanded) {
            setStateExpanded(false);
        }
    }, [mainReducer.state.budgetGenerated]);

    const handleExpandToggle = () => {
        if (!stateExpanded) {
            if (mainReducer.state.budgetGenerated === false) {
                setStateGenerating(true);
                
                const formData = billingForm?.formValues || {};
                const data = {
                    selectedLicense: {
                        ...mainReducer.state.selectedLicense,
                        wantsAnInvoice: billingForm?.wantsAnInvoice ?? false,
                        ...formData
                    },
                    environment: environment.entorno,
                    user: mainReducer.state.user.id,
                    budget: environment.budget
                };
                
                generateBudget(data).then(budgetData => {
                    mainReducer.dispatch({
                        type: 'setBudgetGenerated',
                        payload: budgetData
                    });
                    setStateGenerating(false);
                    setStateExpanded(true);
                }).catch(() => {
                    setStateGenerating(false);
                });
            } else {
                setStateExpanded(true);
            }
        } else {
            setStateExpanded(false);
        }
    };

    const handleOnFocus = () => {
        inputPayForMe.current.select();
        inputPayForMe.current.setSelectionRange(0,99999);
    }

    const handleCopyLink = () => {
        handleOnFocus();
        navigator.clipboard.writeText(inputPayForMe.current.value);
        handleOnCopy();
    }

    const handleOnCopy = () => {
        if (!stateCopied) {
            setStateCopied(true);
            markBudgetAsSeen({
                environment: environment.entorno,
                budget: mainReducer.state.budgetGenerated
            });
        }
    }

    return <fieldset className={`e__plns__link e__plns__link--${mainReducer.state.selectedLicense.id}${(config.plans[mainReducer.state.selectedLicense.id].highlight) ? ' e__plns__link--highlight' : ''}`}>
                <legend style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <div className='e__plns__legend__container' onClick={handleExpandToggle} style={{ cursor: 'pointer', flex: 1 }}>
                        <span className="e__plns__link__ico">
                            <SVG_payforme />
                        </span>
                        { getText('pagar_por_mi') }
                        <span className="e__btn__info">
                            <button className="e__btn" onClick={(e) => e.stopPropagation()} aria-label={ getText('mas_informacion') } title={ getText('mas_informacion') }>i</button>
                            <span className="e__btn__info__wp">
                                { getText('pagar_por_mi_txt') }
                            </span>
                        </span>
                    </div>

                     <button 
                        type="button"
                        className={`e__plns__link__chevron ${stateExpanded ? 'e__plns__link__chevron--expanded' : ''}`}
                        onClick={(e) => { e.stopPropagation(); handleExpandToggle(); }}
                        aria-label={stateExpanded ? getText('contraer') : getText('expandir')}
                    >
                        <SVG_chevron_down />
                    </button>
                </legend>
                {(stateExpanded) && (
                    (stateGenerating || mainReducer.state.budgetGenerated === false) ?
                        <BlockLoading />
                    :
                        <div className="e__plns__link__wpr">
                            <div className="e-form e-form--success e-form--ico">
                                <label>{ getText('pagar_por_mi_txt2') }</label>
                                <div className="e-form__wrapper">
                                    <span className="e-form__input">
                                        <input placeholder=" " onCopy={ handleOnCopy } onFocus={ handleOnFocus } ref={ inputPayForMe } dir="ltr" readOnly size="45" title={ getText('pagar_por_mi_txt2') } value={ getURL(environment,'shortcutBudget') + mainReducer.state.budgetGenerated + '/' + ((environment.showConsent == 'no') ? '?showConsent=no' : '') } />
                                    </span>
                                    <span className="e-icon">
                                        <SVG_link />
                                    </span>
                                    <button className="e-btn e-btn--secondary"  onClick={ handleCopyLink }>
                                        <span className="e-icon">
                                            <SVG_copy />
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                )}
            </fieldset>
}